export const fideliteLinks = [
  {
    id: 'programme',
    title: 'Mon programme',
    link: '/tableau-de-bord/ma-fidelite'
  },
  {
    id: 'recompenses',
    title: 'Mes récompenses',
    link: '/tableau-de-bord/ma-fidelite/offres'
  },
  {
    id: 'trophees',
    title: 'Mes trophées',
    link: '/tableau-de-bord/ma-fidelite/trophees'
  },
  {
    id: 'historique',
    title: 'Mon historique',
    link: '/tableau-de-bord/ma-fidelite/historique'
  },
  {
    id: 'faq',
    title: 'FAQ',
    link: '/tableau-de-bord/ma-fidelite/faq'
  }
];

export const explanationModalLinks = [
  // {
  //   id: 'points',
  //   title: 'LES POINTS',
  //   tab: 'points'
  // },
  {
    id: 'badges',
    title: 'LES BADGES',
    tab: 'badges'
  }
  // {
  //   id: 'statut',
  //   title: 'LE STATUT',
  //   tab: 'statut'
  // }
];
